import React from "react";
import "styles/Banner.scss";

const Banner = () => {
  return (
    <div id="banner-container">
      <div className="banner-img-container">
        <div className="text-container">
          <p className="headline">Your HSC subject selection guide</p>
          <p className="intro">
            Start by selecting a category below. Complete all the steps or skip
            through to the end at any time.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Banner;
